import { deepFreeze } from 'utils/deepFreeze';
import type { QuickShopWidgetState } from '../types';

export const initialState: Readonly<QuickShopWidgetState> = deepFreeze({});
